import { IThoiKhoaBieu } from "../../../model/respone/classes/IThoiKhoaBieu";
import { formatThu, formatTiet } from "../classesHelpers";

interface ITkbAgendaProps {
    tkbs?: IThoiKhoaBieu[];
    /** GV cấp lớp — fallback khi buổi học thiếu `ho_ten`. */
    classLevelGv?: string;
}

/**
 * Rút gọn 4 cột "Thời khóa biểu" (Thời gian/Thứ/Tiết/Phòng) của bản desktop
 * thành danh sách agenda theo buổi — mỗi buổi 1 dòng, dễ đọc trên màn hình dọc.
 */
const TkbAgenda = ({ tkbs, classLevelGv }: ITkbAgendaProps) => {
    if (!tkbs || tkbs.length === 0) {
        return (
            <div className="m-tkb">
                <div className="m-tkb-empty">Chưa có lịch học</div>
            </div>
        );
    }

    return (
        <div className="m-tkb">
            {tkbs.map((tkb, idx) => {
                const dayLabel = tkb.thu === 8 ? "CN" : `Thứ ${formatThu(tkb.thu)}`;
                const gv = tkb.ho_ten || classLevelGv;
                const dateRange =
                    tkb.tu_ngay && tkb.den_ngay ? `${tkb.tu_ngay} – ${tkb.den_ngay}` : "";
                return (
                    <div className="m-tkb-row" key={idx}>
                        <span className="m-tkb-day">{dayLabel}</span>
                        <span className="m-tkb-info">
                            <strong>Tiết {formatTiet(tkb.tiet, tkb.so_tiet)}</strong>
                            {tkb.phong ? ` · Phòng ${tkb.phong}` : ""}
                            <br />
                            <span className="m-tkb-sub">
                                {dateRange}
                                {dateRange && gv ? " · " : ""}
                                {gv ? `GV: ${gv}` : ""}
                            </span>
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default TkbAgenda;
